// removed by extract-text-webpack-plugin
module.exports = {"fair-banner":"fair-banner","center":"center","fair-banner-img-mobile":"fair-banner-img-mobile","fair-group":"fair-group","fair-time":"fair-time","fair-button":"fair-button"};


//////////////////
// WEBPACK FOOTER
// ./components/fair/sub-view/banner/style.scss
// module id = ./components/fair/sub-view/banner/style.scss
// module chunks = 0